import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    width: "100%",
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
}));


const SarasChipContainer = ({children}) => {
  const classes = useStyles();

  return (
    <Paper component="ul" className={classes.root}>
      {children}
    </Paper>
  );
}

export default SarasChipContainer;
